var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsWomanOn = function SvgPartsWomanOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF540F",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6.095c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m.571 12.593V15.2c2.578-.287 4.572-2.496 4.572-5.106A5.15 5.15 0 0 0 16 4.952a5.15 5.15 0 0 0-5.143 5.143c0 2.61 1.994 4.82 4.572 5.106v3.487H9.714v1.143h5.715v7.217h1.142V19.83h5.715v-1.143zM6.095 10.667a4.571 4.571 0 1 1 0-9.143 4.571 4.571 0 0 1 0 9.143M5.133 8.7 2.868 6.435l.68-.68L5.133 7.34l3.51-3.51.68.68z"
  }))));
};
export default SvgPartsWomanOn;